import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { Title } from '@angular/platform-browser'
import { AngularFireAuth } from '@angular/fire/auth';
import firebase from 'firebase/app';
import { AngularFirestore } from '@angular/fire/firestore';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  constructor(private router: Router, public auth: AngularFireAuth,
    private afs: AngularFirestore
  ) {
  }

  login() {
    this.auth.signInWithPopup(new firebase.auth.GoogleAuthProvider()).then(
      (info: any) => {
        let id = info.user?.uid;
        this.afs.doc(`Users/${id}`).set({
          name: info.user?.displayName,
          uid: id,
          photo: info.user?.photoURL,
          loggedIn: new Date(),
          sinceMember: info.user.metadata.creationTime
        }).then((data: any) => {
          alert('Login successful');
          this.router.navigate(['/']);
        });
      }
    );


  }
  logout() {
    this.auth.signOut();
  }
}